import React, { useState } from 'react';
import { CONTACT } from '../mock';
import { Phone, MapPin, MessageCircle, Shield, Clock, ExternalLink } from 'lucide-react';
import RefundPolicyDialog from './RefundPolicyDialog';

const MAP_URL = 'https://maps.app.goo.gl/5EW2N7UWyiQ6uo2W9';
const ADDRESS_FULL = 'Opp. Welcare Hospital, Nr. Premwati Circle, Atladara, Vadodara - 390012';
const TIMING = 'Monday to Saturday · 09:30 AM – 07:30 PM';

export default function Footer() {
  const [openRefund, setOpenRefund] = useState(false);
  return (
    <footer className="relative border-t border-purple-900/40 bg-[#08080d] pt-14 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6 grid md:grid-cols-3 gap-6 md:gap-8">
        <div>
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-full flex items-center justify-center text-white font-bold text-sm" style={{background:'linear-gradient(135deg,#a855f7,#ec4899)'}}>OS</div>
            <div>
              <div className="font-extrabold text-white">ONE STOP <span className="gradient-text">CARZ</span></div>
              <div className="text-xs text-gray-400">{CONTACT.tagline}</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-gray-400 max-w-md">વડોદરાનું ભરોસાપાત્ર મલ્ટીબ્રાન્ડ કાર વર્કશોપ. જેન્યુઈન પાર્ટ્સ, પારદર્શક ભાવ અને સર્વિસ વોરંટી.</p>
          <div className="mt-4 flex flex-wrap gap-2">
            <a href={`tel:+91${CONTACT.phone}`} className="inline-flex items-center gap-2 text-xs text-gray-300 border border-purple-900/60 hover:border-pink-500/70 rounded-full px-3 py-1.5"><Phone className="w-3.5 h-3.5 text-pink-400" /> {CONTACT.phoneDisplay}</a>
            <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-xs text-gray-300 border border-purple-900/60 hover:border-pink-500/70 rounded-full px-3 py-1.5"><MessageCircle className="w-3.5 h-3.5 text-green-400" /> WhatsApp</a>
          </div>
        </div>

        <div>
          <div className="text-white font-semibold mb-2.5 text-sm">અમારું સ્થાન</div>
          <a href={MAP_URL} target="_blank" rel="noreferrer" className="group flex items-start gap-2.5 rounded-lg border border-purple-900/60 hover:border-pink-500/70 bg-[#0f0f16] p-3 transition-colors">
            <MapPin className="w-4 h-4 text-pink-400 shrink-0 mt-0.5" />
            <div className="min-w-0">
              <div className="flex items-center gap-1 text-white text-[13px] font-semibold">
                Google Maps <ExternalLink className="w-3 h-3 opacity-70" />
              </div>
              <div className="text-[11px] text-gray-400 mt-0.5 leading-snug">{ADDRESS_FULL}</div>
            </div>
          </a>
          <div className="mt-2 flex items-start gap-2.5 rounded-lg border border-purple-900/60 bg-[#0f0f16] p-3">
            <Clock className="w-4 h-4 text-pink-400 shrink-0 mt-0.5" />
            <div>
              <div className="text-white text-[13px] font-semibold">Mon – Sat · 09:30 – 19:30</div>
              <div className="text-[11px] text-gray-500">Sunday · બંધ</div>
            </div>
          </div>
        </div>

        <div>
          <div className="text-white font-semibold mb-2.5 text-sm">મેન્યુ</div>
          <ul className="text-sm text-gray-400 space-y-1.5">
            <li><a href="#packages" className="hover:text-white">પેકેજ</a></li>
            <li><a href="#amc" className="hover:text-white">Diamond AMC</a></li>
            <li><a href="#luxury" className="hover:text-white">Luxury Care</a></li>
            <li><a href="#bodyshop" className="hover:text-white">Bodyshop</a></li>
            <li><a href="#reviews" className="hover:text-white">રિવ્યૂ</a></li>
            <li><a href="#faq" className="hover:text-white">FAQ</a></li>
            <li><button onClick={() => setOpenRefund(true)} className="hover:text-white inline-flex items-center gap-1"><Shield className="w-3.5 h-3.5" /> રિફંડ પૉલિસી</button></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 mt-10 pt-6 border-t border-purple-900/40 text-xs text-gray-500 flex flex-col md:flex-row justify-between gap-2">
        <div>© {new Date().getFullYear()} One Stop Carz. All rights reserved.</div>
        <div className="flex gap-4">
          <button onClick={() => setOpenRefund(true)} className="hover:text-gray-300">Refund Policy</button>
        </div>
      </div>

      <RefundPolicyDialog open={openRefund} onOpenChange={setOpenRefund} />
    </footer>
  );
}
